import React, { useState } from 'react';
import { Tab, Tabs, Typography } from '@mui/material';
import { Link as RouterLink, Outlet, matchPath, useLocation, useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const tabs = [
  {
    label: 'Preferences.ShoppingTab',
    routeFR: '/compte/preferences-magasinage',
    routeEN: '/account/shopping-preferences',
  },
  {
    label: 'Preferences.CommunicationsTab',
    routeFR: '/compte/preferences-communications',
    routeEN: '/account/communication-preferences',
  },
];

const PreferencesBase = (): JSX.Element => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { t, i18n } = useTranslation('component');
  const { pathname } = useLocation();

  let selectedTab = tabs.findIndex((tab) =>
    matchPath(
      `/${i18n.resolvedLanguage}${i18n.resolvedLanguage == 'fr' ? tab.routeFR : tab.routeEN}`,
      pathname.toLocaleLowerCase()
    )
  );

  if (selectedTab == -1) {
    selectedTab = tabs.findIndex((tab) =>
      matchPath(
        `/${i18n.resolvedLanguage}${i18n.resolvedLanguage == 'en' ? tab.routeFR : tab.routeEN}`,
        pathname.toLocaleLowerCase()
      )
    );
  }

  return (
    <>
      <Typography variant="h1" sx={{ mb: '16px' }}>
        {t('Preferences.Title')}
      </Typography>
      <Tabs value={selectedTab} sx={{ mb: '32px' }}>
        {tabs.map((tab) => (
          <Tab
            disabled={isLoading}
            key={i18n.resolvedLanguage == 'fr' ? tab.routeFR : tab.routeEN}
            label={t(tab.label)}
            to={`/${i18n.resolvedLanguage}${i18n.resolvedLanguage == 'fr' ? tab.routeFR : tab.routeEN}`}
            component={RouterLink}
          />
        ))}
      </Tabs>
      <Outlet context={{ isLoading, setIsLoading }} />
    </>
  );
};

export const useLoading = (): {
  isLoading: boolean;
  setIsLoading: (value: boolean | ((prevVar: boolean) => boolean)) => void;
} => {
  return useOutletContext<{
    isLoading: boolean;
    setIsLoading: (value: boolean | ((prevVar: boolean) => boolean)) => void;
  }>();
};

export default PreferencesBase;
